import { Component } from '@angular/core';
import { FieldArrayType, FormlyFieldConfig } from '@ngx-formly/core';
import { AIBtnEvent } from '../../../models';

export type AIButtonProps = {
  disabled?: boolean;
  inputAppendClassAI?: string[];
  labelAIType?: 'btn-fill' | 'btn-transparent' | 'btn-icon';
  labelAILabel?: string;
  labelAIPrompt?: boolean;
  labelAIPromptLabel?: string;
  labelAIPromptPlaceholder?: string;
  aiButtonEvent?: (event: AIBtnEvent, field: FormlyFieldConfig) => void;
};

@Component({
  selector: 'app-formly-ai-button',
  template: `
    <div [class]="props.inputAppendClassAI ? props.inputAppendClassAI.join(' ') : ''">
      <app-ai-button
        [type]="props.labelAIType!"
        [label]="props.labelAILabel!"
        [prompt]="props.labelAIPrompt!"
        [promptLabel]="props.labelAIPromptLabel!"
        [promptPlaceholder]="props.labelAIPromptPlaceholder!"
      >
      </app-ai-button>
    </div>
  `,
  styles: [
    `
      :host {
        @apply w-full;
      }
    `,
  ],
})
export class FormlyAIButtonTypeComponent extends FieldArrayType<FormlyFieldConfig<AIButtonProps>> {
  aiEvent(event: AIBtnEvent) {
    this.props.aiButtonEvent?.(event, this.field);
  }
}
